<template>
  <div class="user-form-container">

    <!-- ── PAGE HEADER ── -->
    <div class="page-header">
      <div class="breadcrumb">
        ຈັດການລະບົບ /
        <span @click="$router.push('/home/system/users')" class="bc-link">ຜູ້ໃຊ້ງານ</span>
        / <span>{{ isEdit ? 'ແກ້ໄຂ' : 'ເພີ່ມໃໝ່' }}</span>
      </div>
      <div class="header-row">
        <div class="header-left">
          <h1>
            <i :class="isEdit ? 'fas fa-user-edit' : 'fas fa-user-plus'"></i>
            {{ isEdit ? 'ແກ້ໄຂຂໍ້ມູນຜູ້ໃຊ້' : 'ລົງທະບຽນຜູ້ໃຊ້ໃໝ່' }}
          </h1>
          <p>{{ isEdit ? 'ອັບເດດຂໍ້ມູນຜູ້ໃຊ້ງານໃນລະບົບ' : 'ເພີ່ມຜູ້ໃຊ້ງານໃໝ່ເຂົ້າລະບົບ' }}</p>
        </div>
        <button class="btn-back" @click="$router.push('/home/system/users')">
          <i class="fas fa-arrow-left"></i> ກັບຄືນ
        </button>
      </div>
    </div>

    <!-- ── LOADING ── -->
    <div v-if="pageLoading" class="page-loading">
      <i class="fas fa-spinner fa-spin fa-2x"></i>
      <p>ກຳລັງໂຫຼດຂໍ້ມູນ...</p>
    </div>

    <form v-else @submit.prevent="handleSubmit">
      <div class="form-layout">

        <!-- ═══════════════════════════════════════
             SECTION 1: ຂໍ້ມູນພື້ນຖານ
        ═══════════════════════════════════════════ -->
        <div class="card">
          <div class="card-head">
            <div class="card-head-icon"><i class="fas fa-id-card"></i></div>
            <span>ຂໍ້ມູນພື້ນຖານ</span>
          </div>
          <div class="card-body">

            <div class="field-row">
              <div class="form-group">
                <label>ຊື່ ແລະ ນາມສະກຸນ <span class="req">*</span></label>
                <input v-model="form.fullname" type="text" placeholder="ປ້ອນຊື່ເຕັມ" required />
              </div>
              <div class="form-group">
                <label>ຊື່ຜູ້ໃຊ້ (Username) <span class="req">*</span></label>
                <input v-model="form.username" type="text" placeholder="username"
                       :disabled="isEdit" :class="{ 'input-readonly': isEdit }" required />
                <div class="field-hint" v-if="isEdit">
                  <i class="fas fa-lock"></i> ບໍ່ສາມາດປ່ຽນ username ໄດ້
                </div>
              </div>
            </div>

            <div class="field-row" v-if="!isEdit">
              <div class="form-group">
                <label>ລະຫັດຜ່ານ <span class="req">*</span></label>
                <div class="input-pw-wrap">
                  <input v-model="form.password" :type="showPwd ? 'text' : 'password'"
                         placeholder="ຢ່າງໜ້ອຍ 6 ຕົວ" required />
                  <button type="button" class="toggle-pw" @click="showPwd = !showPwd">
                    <i :class="showPwd ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                  </button>
                </div>
                <div v-if="form.password && form.password.length < 6" class="field-error">
                  ລະຫັດຜ່ານຕ້ອງມີຢ່າງໜ້ອຍ 6 ຕົວ
                </div>
              </div>
              <div class="form-group">
                <label>ຢືນຢັນລະຫັດຜ່ານ <span class="req">*</span></label>
                <div class="input-pw-wrap">
                  <input v-model="form.confirmPwd" :type="showPwd ? 'text' : 'password'"
                         placeholder="ປ້ອນລະຫັດຜ່ານອີກຄັ້ງ" />
                </div>
                <div v-if="form.confirmPwd && form.password !== form.confirmPwd" class="field-error">
                  ລະຫັດຜ່ານບໍ່ກົງກັນ
                </div>
              </div>
            </div>

            <div class="field-row">
              <div class="form-group">
                <label>ອີເມວ</label>
                <input v-model="form.email" type="email" placeholder="example@gmail.com" />
              </div>
              <div class="form-group">
                <label>ເບີໂທລະສັບ</label>
                <input v-model="form.mobile_number" type="text" placeholder="020 5xxxxxxx" />
              </div>
            </div>

          </div>
        </div>

        <!-- ═══════════════════════════════════════
             SECTION 2: ສັງກັດ ແລະ ສິດທິ
        ═══════════════════════════════════════════ -->
        <div class="card">
          <div class="card-head">
            <div class="card-head-icon"><i class="fas fa-sitemap"></i></div>
            <span>ສັງກັດ ແລະ ສິດທິ</span>
          </div>
          <div class="card-body">

            <!-- Org Role -->
            <div class="form-group">
              <label>ປະເພດບັນຊີ <span class="req">*</span></label>
              <div class="select-wrap">
                <i class="fas fa-building sel-icon"></i>
                <select v-model="form.org_role" @change="onOrgRoleChange">
                  <option value="school">ໂຮງຮຽນ</option>
                  <option value="desb">ຫ້ອງການສຶກສາ ແລະ ກິລາເມືອງ (DESB)</option>
                  <option value="pess">ພະແນກສຶກສາ ແລະ ກິລາແຂວງ (PESS)</option>
                  <option value="consulate">ກົງສຸນ (Consulate)</option>
                </select>
              </div>
              <div class="field-hint">
                <i class="fas fa-info-circle"></i> ໃຊ້ກຳນົດຂອບເຂດການອະນຸມັດຄຳຮ້ອງຍົກຍ້າຍນັກຮຽນ (DESB/PESS) ຫຼື ຄຸ້ມຄອງນັກສຶກສາຮຽນຕ່າງປະເທດ (ກົງສຸນ)
              </div>
            </div>

            <!-- Country -->
            <div class="form-group">
              <label>ປະເທດ <span class="req">*</span></label>
              <div class="select-wrap">
                <i class="fas fa-globe-asia sel-icon"></i>
                <select v-model="form.country" @change="onCountryChange">
                  <option value="Laos">ລາວ (Laos)</option>
                  <option v-for="c in otherCountries" :key="c" :value="c">{{ c }}</option>
                </select>
              </div>
              <div class="field-hint">
                <i class="fas fa-info-circle"></i> ຖ້າເລືອກ "ລາວ" ຈຶ່ງຈະສາມາດເລືອກແຂວງ ແລະ ຂໍ້ມູນໂຮງຮຽນໄດ້
              </div>
            </div>

            <!-- Province -->
            <div class="form-group" v-if="form.country === 'Laos'">
              <label>ແຂວງ <span class="req">*</span></label>
              <div class="select-wrap">
                <i class="fas fa-map-marker-alt sel-icon"></i>
                <select v-model="form.prov_id" @change="onProvChange" :class="{ loading: provLoading }">
                  <option value="">-- ເລືອກແຂວງ --</option>
                  <option v-for="p in provinces" :key="p.value" :value="p.value">{{ p.text }}</option>
                </select>
                <div v-if="provLoading" class="sel-spinner">
                  <i class="fas fa-spinner fa-spin"></i>
                </div>
              </div>
            </div>

            <!-- District -->
            <div class="form-group" v-if="form.country === 'Laos' && form.org_role !== 'pess'">
              <label>ເມືອງ <span class="req">*</span></label>
              <div class="select-wrap">
                <i class="fas fa-city sel-icon"></i>
                <select v-model="form.district_id" @change="onDistChange"
                        :disabled="!form.prov_id || distLoading">
                  <option value="">{{ form.prov_id ? '-- ເລືອກເມືອງ --' : 'ເລືອກແຂວງກ່ອນ' }}</option>
                  <option v-for="d in districts" :key="d.value" :value="d.value">{{ d.text }}</option>
                </select>
                <div v-if="distLoading" class="sel-spinner">
                  <i class="fas fa-spinner fa-spin"></i>
                </div>
              </div>
            </div>

            <!-- School — searchable dropdown -->
            <div class="form-group" v-if="form.country === 'Laos' && form.org_role === 'school'">
              <label>ໂຮງຮຽນ / ສັງກັດ</label>
              <div class="school-pick" :class="{ 'pick-disabled': !form.district_id || schoolLoading }">
                <div class="pick-input-wrap">
                  <i class="fas fa-school pick-icon"></i>
                  <input
                    ref="schoolInput"
                    v-model="schoolSearch"
                    :placeholder="schoolInputPlaceholder"
                    :disabled="!form.district_id || schoolLoading"
                    autocomplete="off"
                    @focus="schoolOpen = true"
                    @blur="onSchoolBlur"
                  />
                  <button v-if="form.school_id" type="button" class="pick-clear"
                          @mousedown.prevent="clearSchool" title="ລຶງ">
                    <i class="fas fa-times-circle"></i>
                  </button>
                  <i v-else-if="schoolLoading" class="fas fa-spinner fa-spin pick-arrow"></i>
                  <i v-else class="fas fa-chevron-down pick-arrow"></i>
                </div>
                <ul v-if="schoolOpen && !schoolLoading" class="pick-list">
                  <li v-if="filteredSchools.length === 0" class="pick-empty">
                    <i class="fas fa-search"></i> ບໍ່ພົບໂຮງຮຽນ
                  </li>
                  <li v-for="s in filteredSchools" :key="s.school_id"
                      :class="{ 'pick-active': s.school_id === form.school_id }"
                      @mousedown.prevent="pickSchool(s)">
                    <i class="fas fa-school pick-li-icon"></i>
                    <div class="pick-school-info">
                      <span class="pick-school-name">{{ s.school_name_lao }}</span>
                      <div class="pick-school-meta">
                        <span class="pick-emis">{{ s.school_id }}</span>
                        <span v-if="s.school_level_lao" class="pick-level">{{ s.school_level_lao }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Level + Active -->
            <div class="field-row">
              <div class="form-group">
                <label>ລະດັບສິດ <span class="req">*</span></label>
                <div class="select-wrap">
                  <i class="fas fa-shield-alt sel-icon"></i>
                  <select v-model.number="form.user_level">
                    <option :value="1">Admin — ຜູ້ເບິ່ງແຍງລະບົບ</option>
                    <option :value="2">Manager — ຜູ້ບໍລິຫານ</option>
                    <option :value="3">Teacher — ຄູສອນ</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label>ສະຖານະ</label>
                <div class="radio-group">
                  <label class="radio-opt" :class="{ selected: form.active === 1 }">
                    <input type="radio" v-model.number="form.active" :value="1" />
                    <i class="fas fa-check-circle"></i> ເປີດໃຊ້ງານ
                  </label>
                  <label class="radio-opt" :class="{ selected: form.active === 0 }">
                    <input type="radio" v-model.number="form.active" :value="0" />
                    <i class="fas fa-ban"></i> ປິດໃຊ້ງານ
                  </label>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div><!-- /form-layout -->

      <!-- ── FORM ACTIONS ── -->
      <div class="form-actions">
        <button type="button" class="btn-cancel" @click="$router.push('/home/system/users')">
          <i class="fas fa-times"></i> ຍົກເລີກ
        </button>
        <button type="submit" class="btn-save" :disabled="submitting || !isFormValid">
          <i class="fas" :class="submitting ? 'fa-spinner fa-spin' : 'fa-save'"></i>
          {{ submitting ? 'ກຳລັງບັນທຶກ...' : (isEdit ? 'ອັບເດດຂໍ້ມູນ' : 'ບັນທຶກຜູ້ໃຊ້') }}
        </button>
      </div>
    </form>

    <!-- ── TOAST ── -->
    <transition name="toast-slide">
      <div v-if="toast.show" :class="['toast', toast.type]">
        <i :class="toast.type === 'success' ? 'fas fa-check-circle' : 'fas fa-exclamation-circle'"></i>
        {{ toast.msg }}
      </div>
    </transition>

  </div>
</template>

<script>
import api from '@/utils/api';
import { COUNTRIES } from '@/utils/countries';

const EMPTY_FORM = () => ({
  username: '',
  password: '',
  confirmPwd: '',
  fullname: '',
  email: '',
  mobile_number: '',
  prov_id: '',
  district_id: '',
  school_id: '',
  org_role: 'school',
  country: 'Laos',
  user_level: 2,
  org_type_code: '1',
  lang: '1',
  active: 1,
});

export default {
  name: 'UserFormPage',
  props: ['id'],
  data() {
    return {
      isEdit: false,
      pageLoading: false,
      submitting: false,
      showPwd: false,
      form: EMPTY_FORM(),
      provinces: [],
      districts: [],
      schools: [],
      provLoading: false,
      distLoading: false,
      schoolLoading: false,
      schoolSearch: '',
      schoolOpen: false,
      toast: { show: false, type: 'success', msg: '' },
    };
  },
  computed: {
    filteredSchools() {
      const q = this.schoolSearch.toLowerCase().trim();
      if (!q) return this.schools;
      return this.schools.filter(s =>
        (s.school_name_lao || '').toLowerCase().includes(q) ||
        (s.school_id       || '').toLowerCase().includes(q)
      );
    },
    selectedSchoolName() {
      if (!this.form.school_id) return '';
      const s = this.schools.find(x => x.school_id === this.form.school_id);
      if (!s) return '';
      return s.school_level_lao
        ? `[${s.school_id}] ${s.school_name_lao} (${s.school_level_lao})`
        : `[${s.school_id}] ${s.school_name_lao}`;
    },
    schoolInputPlaceholder() {
      if (!this.form.district_id) return 'ເລືອກເມືອງກ່ອນ';
      if (this.form.school_id && !this.schoolOpen) return this.selectedSchoolName;
      return 'ຄົ້ນຫາ ຊື່ / ລະຫັດໂຮງຮຽນ...';
    },
    isFormValid() {
      if (!this.form.fullname || !this.form.username || !this.form.country) return false;
      if (this.form.country === 'Laos' && !this.form.prov_id) return false;
      if (!this.isEdit) {
        if (!this.form.password || this.form.password.length < 6) return false;
        if (this.form.password !== this.form.confirmPwd) return false;
      }
      return true;
    },
    otherCountries() {
      return COUNTRIES.filter(c => c !== 'Laos');
    },
  },
  async mounted() {
    await this.fetchProvinces();
    const routeId = this.$route.params.id || this.id;
    if (routeId) {
      this.isEdit = true;
      await this.fetchUserData(routeId);
    }
  },
  methods: {
    async fetchProvinces() {
      this.provLoading = true;
      try {
        const res = await api.get('/getItems/province/prov_name/prov_id');
        this.provinces = Array.isArray(res.data) ? res.data : (res.data.rows || []);
      } catch (e) { console.error(e); }
      finally { this.provLoading = false; }
    },

    async fetchDistricts(provId) {
      if (!provId) { this.districts = []; return; }
      this.distLoading = true;
      try {
        const res = await api.get(`/getItemsCondition/district/district_name_lao/district_id/prov_id/${provId}`);
        this.districts = Array.isArray(res.data) ? res.data : (res.data.rows || []);
      } catch (e) { console.error(e); }
      finally { this.distLoading = false; }
    },

    async fetchSchools(distId) {
      if (!distId) { this.schools = []; return; }
      this.schoolLoading = true;
      try {
        const res = await api.get(`/schools/list-by-district/${distId}`);
        this.schools = res.data.rows || [];
      } catch (e) { console.error(e); }
      finally { this.schoolLoading = false; }
    },

    onOrgRoleChange() {
      if (this.form.org_role === 'pess' || this.form.org_role === 'consulate') {
        this.form.district_id = '';
        this.form.school_id = '';
        this.schoolSearch = '';
      } else if (this.form.org_role === 'desb') {
        this.form.school_id = '';
        this.schoolSearch = '';
      }
    },

    onCountryChange() {
      if (this.form.country !== 'Laos') {
        this.form.prov_id = '';
        this.form.district_id = '';
        this.form.school_id = '';
        this.schoolSearch = '';
        this.districts = [];
        this.schools = [];
      }
    },

    async onProvChange() {
      this.form.district_id = '';
      this.form.school_id   = '';
      this.districts = [];
      this.schools   = [];
      await this.fetchDistricts(this.form.prov_id);
    },

    async onDistChange() {
      this.form.school_id = '';
      this.schoolSearch   = '';
      this.schoolOpen     = false;
      this.schools = [];
      await this.fetchSchools(this.form.district_id);
    },

    pickSchool(s) {
      this.form.school_id = s.school_id;
      this.schoolSearch   = '';
      this.schoolOpen     = false;
    },
    clearSchool() {
      this.form.school_id = '';
      this.schoolSearch   = '';
      this.schoolOpen     = false;
      this.$nextTick(() => this.$refs.schoolInput && this.$refs.schoolInput.focus());
    },
    onSchoolBlur() {
      setTimeout(() => { this.schoolOpen = false; }, 150);
    },

    async fetchUserData(id) {
      this.pageLoading = true;
      try {
        const res = await api.get(`/users/${id}`);
        if (res.data.code === 1) {
          const u = res.data.item;
          this.form = { ...EMPTY_FORM(), ...u, confirmPwd: '' };
          if (u.prov_id) {
            await this.fetchDistricts(u.prov_id);
            if (u.district_id) await this.fetchSchools(u.district_id);
          }
        } else {
          this.showToast('error', res.data.desc || 'ບໍ່ພົບຂໍ້ມູນຜູ້ໃຊ້');
          setTimeout(() => this.$router.push('/home/system/users'), 2000);
        }
      } catch (e) {
        console.error(e);
        this.showToast('error', 'ບໍ່ສາມາດດຶງຂໍ້ມູນຜູ້ໃຊ້ໄດ້');
      } finally {
        this.pageLoading = false;
      }
    },

    async handleSubmit() {
      if (!this.isFormValid) return;
      this.submitting = true;
      try {
        let res;
        if (this.isEdit) {
          const items = { ...this.form };
          delete items.confirmPwd;
          delete items.password;
          delete items._id;
          res = await api.put(`/users/${this.form._id}`, { items });
        } else {
          const item = { ...this.form };
          delete item.confirmPwd;
          res = await api.post('/adduser', { item });
        }

        if (res.data.code === 1) {
          this.showToast('success', this.isEdit ? 'ອັບເດດຂໍ້ມູນສຳເລັດ' : 'ລົງທະບຽນຜູ້ໃຊ້ສຳເລັດ');
          setTimeout(() => this.$router.push('/home/system/users'), 1500);
        } else {
          this.showToast('error', res.data.desc || 'ເກີດຂໍ້ຜິດພາດໃນການບັນທຶກ');
        }
      } catch (e) {
        console.error(e);
        this.showToast('error', 'ບໍ່ສາມາດເຊື່ອມຕໍ່ກັບເຊີເວີ');
      } finally {
        this.submitting = false;
      }
    },

    showToast(type, msg) {
      this.toast = { show: true, type, msg };
      setTimeout(() => { this.toast.show = false; }, 3500);
    },
  },
};
</script>

<style scoped>
/* ─────── Base ─────── */
.user-form-container { animation: fadeIn 0.35s ease; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: none; } }

/* ─────── Header ─────── */
.header-row  { display: flex; justify-content: space-between; align-items: flex-start; margin-top: 8px; flex-wrap: wrap; gap: 12px; }
.header-left h1 { font-size: 1.4rem; color: #311B92; margin: 0 0 4px; }
.header-left p  { color: var(--text3); font-size: 13px; margin: 0; }
.bc-link { cursor: pointer; color: #4527A0; }
.bc-link:hover { text-decoration: underline; }

.btn-back {
  display: flex; align-items: center; gap: 8px;
  background: #f1f5f9; color: var(--text2); border: 1px solid var(--border);
  padding: 9px 18px; border-radius: 10px; font-size: 13px; font-weight: 600;
  cursor: pointer; white-space: nowrap; transition: all .2s;
}
.btn-back:hover { background: #e2e8f0; }

/* ─────── Page Loading ─────── */
.page-loading { display: flex; flex-direction: column; align-items: center;
                justify-content: center; padding: 80px 0; color: var(--text3); gap: 12px; }

/* ─────── Layout ─────── */
.form-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 20px; }
@media (max-width: 860px) { .form-layout { grid-template-columns: 1fr; } }

/* ─────── Card ─────── */
/* ບໍ່ໃຊ້ overflow:hidden ເພາະ dropdown pick-list ຈະຖືກ clip */
.card { background: #fff; border-radius: 14px; box-shadow: 0 2px 12px rgba(0,0,0,.07); }
.card-head {
  display: flex; align-items: center; gap: 10px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #4527A0, #311B92);
  color: #fff; font-size: 15px; font-weight: 700;
  border-radius: 14px 14px 0 0;
}
.card-head-icon { width: 30px; height: 30px; background: rgba(255,255,255,.2);
                  border-radius: 8px; display: flex; align-items: center; justify-content: center; }
.card-body { padding: 20px; }

/* ─────── Fields ─────── */
.field-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.form-group { display: flex; flex-direction: column; gap: 6px; margin-bottom: 14px; }
.form-group:last-child { margin-bottom: 0; }
.form-group label { font-size: 13px; font-weight: 600; color: var(--text2); }
.form-group input, .form-group select {
  padding: 10px 12px; border: 1px solid var(--border);
  border-radius: 8px; font-size: 13px; transition: border .2s;
  width: 100%; box-sizing: border-box;
}
.form-group input:focus, .form-group select:focus {
  border-color: #4527A0; outline: none; box-shadow: 0 0 0 3px rgba(69,39,160,.1);
}
.input-readonly { background: #f8f9fa; color: var(--text3); cursor: not-allowed; }
.field-hint { font-size: 11px; color: var(--text3); }
.field-hint i { margin-right: 4px; }
.field-error { font-size: 11px; color: #C62828; margin-top: 2px; }
.req { color: #e53e3e; }

/* ─────── Password wrap ─────── */
.input-pw-wrap { position: relative; }
.input-pw-wrap input { padding-right: 38px; }
.toggle-pw { position: absolute; right: 10px; top: 50%; transform: translateY(-50%);
             background: none; border: none; color: var(--text3); cursor: pointer; font-size: 14px; }

/* ─────── Select wrap ─────── */
.select-wrap { position: relative; }
.sel-icon { position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
            color: var(--text3); font-size: 13px; pointer-events: none; z-index: 1; }
.select-wrap select { padding-left: 34px; }
.sel-spinner { position: absolute; right: 30px; top: 50%; transform: translateY(-50%);
               color: #4527A0; font-size: 13px; }

/* ─────── School searchable picker ─────── */
.school-pick { position: relative; }
.pick-disabled .pick-input-wrap { background: #f8f9fa; cursor: not-allowed; }
.pick-input-wrap {
  display: flex; align-items: center;
  border: 1px solid var(--border); border-radius: 8px;
  background: #fff; transition: border .2s; overflow: hidden;
}
.school-pick:focus-within .pick-input-wrap { border-color: #4527A0; box-shadow: 0 0 0 3px rgba(69,39,160,.1); }
.pick-icon  { flex-shrink: 0; padding: 0 10px; color: var(--text3); font-size: 13px; }
.pick-input-wrap input {
  flex: 1; padding: 10px 4px; border: none; outline: none;
  font-size: 13px; background: transparent; min-width: 0;
}
.pick-input-wrap input:disabled { cursor: not-allowed; color: var(--text3); }
.pick-clear { background: none; border: none; color: #bbb; cursor: pointer; padding: 0 10px; font-size: 14px; }
.pick-clear:hover { color: #e53e3e; }
.pick-arrow { padding: 0 10px; color: var(--text3); font-size: 12px; pointer-events: none; }

.pick-list {
  position: absolute; left: 0; right: 0; top: calc(100% + 4px);
  background: #fff; border: 1px solid #ddd; border-radius: 10px;
  box-shadow: 0 6px 20px rgba(0,0,0,.10); list-style: none; margin: 0; padding: 4px 0;
  max-height: 220px; overflow-y: auto; z-index: 300;
  /* thin scrollbar */
  scrollbar-width: thin; scrollbar-color: #c5b8ff transparent;
}
.pick-list::-webkit-scrollbar { width: 5px; }
.pick-list::-webkit-scrollbar-track { background: transparent; }
.pick-list::-webkit-scrollbar-thumb { background: #c5b8ff; border-radius: 4px; }

.pick-list li {
  display: flex; align-items: center; gap: 8px;
  padding: 7px 14px; cursor: pointer; font-size: 13px; color: var(--text1);
  transition: background .12s; line-height: 1.4;
}
.pick-list li:hover  { background: #F3EFFF; color: #4527A0; }
.pick-active         { background: #EDE7F6 !important; color: #4527A0; font-weight: 600; }
.pick-li-icon { color: #9575CD; font-size: 11px; flex-shrink: 0; margin-top: 3px; }
.pick-empty { color: var(--text3); justify-content: center; cursor: default; font-style: italic; }
.pick-empty:hover { background: transparent !important; color: var(--text3) !important; }
.pick-school-info { display: flex; flex-direction: column; gap: 1px; min-width: 0; }
.pick-school-name { font-size: 13px; font-weight: 500; line-height: 1.3; white-space: normal; }
.pick-school-meta { display: flex; gap: 6px; align-items: center; margin-top: 2px; }
.pick-emis { font-size: 11px; color: #7E57C2; font-weight: 600; background: #EDE7F6; padding: 1px 6px; border-radius: 4px; white-space: nowrap; }
.pick-level { font-size: 11px; color: #666; white-space: nowrap; }

/* ─────── Radio group ─────── */
.radio-group { display: flex; gap: 10px; }
.radio-opt {
  display: flex; align-items: center; gap: 7px;
  padding: 9px 14px; border: 1.5px solid var(--border);
  border-radius: 9px; cursor: pointer; font-size: 13px; font-weight: 500;
  transition: all .18s; flex: 1; justify-content: center;
}
.radio-opt input[type="radio"] { display: none; }
.radio-opt.selected { border-color: #4527A0; background: #EDE7F6; color: #4527A0; }
.radio-opt:hover:not(.selected) { border-color: #9575CD; }

/* ─────── Form actions ─────── */
.form-actions {
  display: flex; justify-content: flex-end; gap: 12px;
  padding: 16px 0;
}
.btn-cancel {
  display: flex; align-items: center; gap: 8px;
  padding: 11px 22px; border: 1px solid var(--border); background: #fff;
  border-radius: 10px; cursor: pointer; font-size: 14px; font-weight: 600; color: var(--text2);
}
.btn-cancel:hover { background: #f8f9fa; }
.btn-save {
  display: flex; align-items: center; gap: 8px;
  padding: 11px 28px;
  background: linear-gradient(135deg, #4527A0, #311B92);
  color: #fff; border: none; border-radius: 10px;
  font-size: 14px; font-weight: 600; cursor: pointer;
  box-shadow: 0 4px 14px rgba(69,39,160,.35); transition: all .2s;
}
.btn-save:hover:not(:disabled) { box-shadow: 0 6px 18px rgba(69,39,160,.45); }
.btn-save:disabled { opacity: .6; cursor: not-allowed; }

/* ─────── Toast ─────── */
.toast {
  position: fixed; bottom: 28px; right: 28px; z-index: 2000;
  display: flex; align-items: center; gap: 10px;
  padding: 14px 20px; border-radius: 12px; font-size: 14px; font-weight: 600;
  color: #fff; box-shadow: 0 8px 24px rgba(0,0,0,.18); min-width: 240px;
}
.toast.success { background: linear-gradient(135deg, #1B5E20, #2E7D32); }
.toast.error   { background: linear-gradient(135deg, #B71C1C, #C62828); }

.toast-slide-enter-active, .toast-slide-leave-active { transition: all .3s ease; }
.toast-slide-enter { opacity: 0; transform: translateX(40px); }
.toast-slide-leave-to { opacity: 0; transform: translateX(40px); }

@media (max-width: 640px) {
  .field-row { grid-template-columns: 1fr; }
  .radio-group { flex-direction: column; }
}
</style>
